(() => {
  const format = (value, currency = 'PKR') => new Intl.NumberFormat('en-PK', { style: 'currency', currency, minimumFractionDigits: value % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(value / 100);
  const bundleCode = 'LUSHBUNDLE5';
  const eligibleProductIds = new Set([7886129987645,7934537924669,7934538350653,7934539006013,7970663366717,7970665136189,7970665922621,7970666020925,7970666315837,7970666643517,7970666971197,7970667429949]);
  const calculateBundle = (items, options = {}) => {
    const total = items.reduce((sum, item) => sum + item.price, 0);
    const eligible = items.filter((item) => eligibleProductIds.has(item.productId));
    const distinct = new Set(eligible.map((item) => item.productId)).size;
    const percentageSaving = distinct >= 2 ? eligible.reduce((sum, item) => sum + Math.round(item.price * .05), 0) : 0;
    const master = items.find((item) => item.id === Number(options.masterSmallId));
    const shield = items.find((item) => item.id === Number(options.shieldId));
    const duoSaving = options.duoAvailable && master && shield ? Math.max(0, master.price + shield.price - Number(options.duoPrice)) : 0;
    const useDuo = duoSaving > percentageSaving;
    const saving = useDuo ? duoSaving : percentageSaving;
    const cartItems = useDuo ? [...items.filter((item) => item !== master && item !== shield).map(({ id, quantity }) => ({ id, quantity })), { id: Number(options.duoId), quantity: 1 }] : items.map(({ id, quantity }) => ({ id, quantity }));
    return { total, final: total - saving, saving, distinct, useDuo, applyCode: !useDuo && percentageSaving > 0, cartItems, percent: total ? Math.round(saving * 100 / total) : 0 };
  };
  window.LushRootsBundlePricing = { calculate: calculateBundle };
  const cartCodes = (cart) => Array.from(new Set([...(cart.discount_codes || []).map((entry) => entry.code), ...(cart.cart_level_discount_applications || []).filter((entry) => entry.type === 'discount_code').map((entry) => entry.title), ...(cart.items || []).flatMap((item) => (item.line_level_discount_allocations || []).filter((entry) => entry.discount_application?.type === 'discount_code').map((entry) => entry.discount_application.title))].filter(Boolean)));
  const discountWasApplied = (cart) => (cart.discount_codes || []).some((entry) => entry.code?.toUpperCase() === bundleCode && entry.applicable) || (cart.items || []).some((item) => (item.line_level_discount_allocations || []).some((entry) => entry.discount_application?.title?.toUpperCase() === bundleCode && entry.amount > 0)) || (cart.cart_level_discount_applications || []).some((entry) => entry.title?.toUpperCase() === bundleCode && entry.total_allocated_amount > 0);
  let cleaningBundleDiscount = false;
  const maintainBundleEligibility = async (cart) => {
    if (cleaningBundleDiscount || !Array.isArray(cart?.items)) return;
    const codes = cartCodes(cart);
    if (!codes.some((code) => code.toUpperCase() === bundleCode)) return;
    const distinct = new Set(cart.items.filter((item) => eligibleProductIds.has(Number(item.product_id))).map((item) => Number(item.product_id))).size;
    if (distinct >= 2) return;
    cleaningBundleDiscount = true;
    try {
      const cartElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      const sectionSpecs = cartElement?.getSectionsToRender() || [{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
      const sections = sectionSpecs.map((section) => section.section || section.id);
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.filter((code) => code.toUpperCase() !== bundleCode).join(','), sections, sections_url: window.location.pathname }) });
      if (!response.ok) return;
      const updated = await response.json();
      for (const spec of sectionSpecs) {
        const markup = updated.sections?.[spec.section || spec.id];
        if (!markup) continue;
        const html = new DOMParser().parseFromString(markup, 'text/html');
        const container = document.getElementById(spec.id);
        const target = container?.querySelector(spec.selector) || container;
        const source = html.querySelector(spec.selector);
        if (target && source) target.innerHTML = source.innerHTML;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lushroots-discount-check', cartData: updated });
    } catch {} finally { cleaningBundleDiscount = false; }
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData, source }) => { if (source !== 'lushroots-discount-check') maintainBundleEligibility(cartData); });
  const init = (root = document) => {
    root.querySelectorAll('[data-lr-search]').forEach((search) => {
      if (search.dataset.ready) return;
      search.dataset.ready = 'true';
      const summary = search.querySelector('summary');
      const close = (restoreFocus = true) => {
        search.open = false;
        if (restoreFocus) summary.focus();
      };
      search.addEventListener('toggle', () => {
        if (search.open) {
          root.querySelectorAll('.lr-mobile-menu[open]').forEach((menu) => menu.removeAttribute('open'));
          search.querySelector('input[type="search"]').focus();
        }
      });
      search.querySelector('[data-lr-search-close]').addEventListener('click', () => close());
      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
      });
      search.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !search.contains(event.relatedTarget)) close(false);
      });
    });
    root.querySelectorAll('[data-lr-compare]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      el.querySelector('input').addEventListener('input', (event) => el.style.setProperty('--split', event.target.value + '%'));
    });
    root.querySelectorAll('[data-lr-builder]').forEach((builder) => {
      if (builder.dataset.ready) return;
      builder.dataset.ready = 'true';
      const button = builder.querySelector('[data-lr-bundle-add]');
      const error = builder.querySelector('[data-lr-bundle-error]');
      const currency = builder.dataset.currency || 'PKR';
      const summary = builder.querySelector('.lr-bundle-summary');
      const mobileBar = builder.querySelector('[data-lr-bundle-bar]');
      let added = false;
      let selectedCount = 0;
      let inBuilder = false;
      let summaryVisible = true;
      const choice = () => {
        const selected = Array.from(builder.querySelectorAll('[data-lr-item]')).filter((item) => item.querySelector('input').checked).map((item) => {
          const option = item.querySelector('select').selectedOptions[0];
          return { id: Number(option.value), quantity: 1, price: Number(option.dataset.price), productId: Number(item.dataset.productId) };
        });
        return Array.from(new Map(selected.map((item) => [item.productId, item])).values());
      };
      const plan = (items) => calculateBundle(items, { masterSmallId: builder.dataset.masterSmallId, shieldId: builder.dataset.shieldId, duoId: builder.dataset.duoId, duoPrice: builder.dataset.duoPrice, duoAvailable: builder.dataset.duoAvailable === 'true' });
      const syncBar = () => {
        mobileBar.hidden = !inBuilder || summaryVisible || selectedCount === 0;
        document.body.classList.toggle('lr-bundle-active', !mobileBar.hidden);
      };
      const update = () => {
        const items = choice();
        const offer = plan(items);
        selectedCount = items.length;
        added = false;
        const countText = builder.dataset.count.replace('[count]', String(items.length));
        builder.querySelector('[data-lr-selected]').textContent = countText;
        builder.querySelector('[data-lr-mobile-count]').textContent = countText;
        builder.querySelector('[data-lr-total]').textContent = format(offer.final, currency);
        builder.querySelector('[data-lr-mobile-total]').textContent = format(offer.final, currency);
        builder.querySelector('[data-lr-original]').textContent = format(offer.total, currency);
        builder.querySelector('[data-lr-saving]').textContent = '−' + format(offer.saving, currency);
        builder.querySelector('[data-lr-saving-label]').textContent = offer.useDuo ? builder.dataset.duoLabel : builder.dataset.fiveLabel;
        builder.querySelector('[data-lr-breakdown]').hidden = offer.saving <= 0;
        builder.querySelector('[data-lr-offer]').textContent = !items.length ? builder.dataset.select : offer.useDuo ? builder.dataset.duo.replace('[amount]', format(offer.saving, currency)).replace('[percent]', String(offer.percent)) : offer.applyCode ? builder.dataset.discount.replace('[amount]', format(offer.saving, currency)) : builder.dataset.one;
        button.disabled = !items.length;
        button.textContent = builder.dataset.add;
        error.textContent = '';
        syncBar();
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => { inBuilder = entry.isIntersecting; syncBar(); }).observe(builder);
        new IntersectionObserver(([entry]) => { summaryVisible = entry.isIntersecting; syncBar(); }).observe(summary);
      }
      builder.querySelector('[data-lr-review-bundle]').addEventListener('click', () => summary.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' }));
      builder.addEventListener('change', update);
      button.addEventListener('click', async () => {
        const drawer = document.querySelector('cart-drawer');
        if (added) {
          if (drawer) { drawer.setActiveElement(button); drawer.open(); }
          else window.location.assign(window.Shopify.routes.root + 'cart');
          return;
        }
        const chosen = choice();
        if (!chosen.length) return;
        const offer = plan(chosen);
        const payload = { items: offer.cartItems };
        if (drawer) {
          payload.sections = drawer.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          drawer.setActiveElement(button);
        }
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = builder.dataset.adding;
        error.textContent = '';
        let cartResult;
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          cartResult = await response.json();
          if (!response.ok || cartResult.status) throw new Error(cartResult.description || builder.dataset.error);
          added = true;
          if (offer.applyCode) {
            try {
              const previous = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
              if (!previous.ok) throw new Error();
              const cart = await previous.json();
              const codes = Array.from(new Set([...cartCodes(cart), bundleCode]));
              const discountPayload = { discount: codes.join(','), sections: payload.sections, sections_url: window.location.pathname };
              const updated = await fetch(window.Shopify.routes.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(discountPayload) });
              const discounted = await updated.json();
              if (!updated.ok || discounted.status) throw new Error();
              cartResult = discounted;
              if (!discountWasApplied(discounted)) error.textContent = builder.dataset.discountError;
            } catch { error.textContent = builder.dataset.discountError; }
          }
          if (drawer && cartResult.sections && Object.values(cartResult.sections).every((markup) => typeof markup === 'string')) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(cartResult);
            if (error.textContent) {
              const warning = document.createElement('p');
              warning.className = 'lr-cart-discount-error';
              warning.setAttribute('role', 'alert');
              warning.textContent = error.textContent;
              drawer.querySelector('.drawer__footer')?.prepend(warning);
            }
          } else window.location.assign(window.Shopify.routes.root + 'cart');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lushroots-bundle', cartData: cartResult });
        } catch (failure) {
          error.textContent = failure.message || builder.dataset.error;
        } finally {
          button.textContent = added ? builder.dataset.added : builder.dataset.add;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
      update();
    });
    root.querySelectorAll('[data-lr-sticky]').forEach((bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const native = document.getElementById('ProductSubmitButton-' + bar.dataset.section);
      const form = document.getElementById('product-form-' + bar.dataset.section);
      if (!native || !form || !('IntersectionObserver' in window)) return;
      const sync = () => {
        const id = form.querySelector('[name="id"]').value;
        const scope = document.getElementById('MainProduct-' + bar.dataset.section);
        const data = scope?.querySelector('[data-selected-variant]');
        const submit = bar.querySelector('button');
        submit.disabled = native.disabled;
        if (data) {
          try {
            const variant = JSON.parse(data.textContent);
            if (String(variant.id) === id) {
              bar.querySelector('[data-lr-sticky-price]').textContent = format(variant.price, document.documentElement.dataset.lrCurrency || 'PKR');
              bar.querySelector('[data-lr-sticky-size]').textContent = variant.title === 'Default Title' ? '' : variant.title;
            }
          } catch {}
        }
      };
      new IntersectionObserver(([entry]) => {
        bar.hidden = entry.isIntersecting;
        sync();
      }, { threshold: 0 }).observe(native);
      bar.querySelector('button').addEventListener('click', () => {
        sync();
        if (!native.disabled) form.requestSubmit(native);
      });
      form.addEventListener('change', sync);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== String(bar.dataset.section)) return;
        const newValue = data.html.querySelector('[data-lr-value]');
        const oldValue = document.querySelector('[data-lr-value][data-product-id="' + data.variant.product_id + '"]') || document.querySelector('[data-lr-value]');
        if (newValue && oldValue) oldValue.innerHTML = newValue.innerHTML;
        bar.querySelector('[data-lr-sticky-price]').textContent = format(data.variant.price, document.documentElement.dataset.lrCurrency || 'PKR');
        bar.querySelector('[data-lr-sticky-size]').textContent = data.variant.title === 'Default Title' ? '' : data.variant.title;
        bar.querySelector('button').disabled = !data.variant.available;
      });
    });
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('lr-in-view');
          observer.unobserve(entry.target);
        }
      }), { threshold: .12 });
      root.querySelectorAll('[data-lr-reveal]').forEach((el) => observer.observe(el));
    }
  };
  const start = () => {
    init();
    if (Array.from(document.querySelectorAll('.discounts__discount')).some((element) => element.textContent.toUpperCase().includes(bundleCode))) fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.ok ? response.json() : null).then((cart) => maintainBundleEligibility(cart)).catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.lr-mobile-menu[open]').forEach((el) => el.removeAttribute('open'));
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-lr-search][open]').forEach((search) => { if (!search.contains(event.target)) search.open = false; });
    if (event.target.closest('.lr-mobile-menu nav a')) document.querySelector('.lr-mobile-menu')?.removeAttribute('open');
  });
})();
